import type { FunnelStage } from './FunnelStageBadge';
import { ACTIVE_STAGES } from './FunnelStageBadge';
import type { Application } from '../types';
import { StageColumn } from './StageColumn';
import { CollapsedGroup } from './CollapsedGroup';

interface FunnelBoardProps {
  buckets: Record<FunnelStage, Application[]>;
  jobId: number;
  onOpen: (applicationId: number) => void;
}

export function FunnelBoard({ buckets, jobId, onOpen }: FunnelBoardProps) {
  return (
    <div className="overflow-x-auto pb-2">
      <div className="flex gap-3 min-w-max items-start">
        {ACTIVE_STAGES.map((stage) => (
          <StageColumn key={stage} stage={stage} applications={buckets[stage]} jobId={jobId} onOpen={onOpen} />
        ))}
        <CollapsedGroup stage="rejected" applications={buckets.rejected} jobId={jobId} onOpen={onOpen} />
        <CollapsedGroup stage="withdrawn" applications={buckets.withdrawn} jobId={jobId} onOpen={onOpen} />
      </div>
    </div>
  );
}
